import Actions from '../../odata/actions';

const actions = new Actions('subCompetency', 'subCompetencies');

export default actions;
